import { useParams } from 'react-router-dom';
import './ResetPassword.scss';
import { useNavigate } from 'react-router-dom';
import { Form } from 'antd';
import InputPasswordComponent from '../../components/common/InputPasswordComponent/InputPasswordComponent';
import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { resetPassword } from '../../store/actions/auth.action';
import { message } from 'antd';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import { openMessageError } from '../../components/common/Message/openMessageError';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
  const { id, token } = useParams();
  const { t } = useTranslation();

  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const submit = values => {
    dispatch(resetPassword({ id, token, ...values })).then(res => {
      if (res.payload?.data) {
        openMessageSuccess({ content: t('Password reset successfully') });
        navigate('/');
      } else {
        openMessageError({
          content: t('Password reset failed. Please try again'),
        });
      }
    });
  };

  return (
    <div className="slug-account-page flex py-32 px-80 items-start justify-center gap-40 self-stretch">
      <Form
        layout="vertical"
        className="flex flex-col justify-center items-start rounded-[8px] bg-fills-white"
        style={{ width: '600px' }}
        onFinish={submit}
      >
        <div className="flex p-40 pb-24 justify-center items-center gap-8 self-stretch">
          <h2>{t('Reset password')}</h2>
        </div>
        <div className="flex py-16 px-40 flex-col justify-center items-center gap-24 self-stretch">
          <Form.Item
            label={t('New password')}
            name={'new_password'}
            className="self-stretch"
            help={false}
            rules={[
              { required: true },
              {
                validator: (_, value) => {
                  const errors = [];
                  if (value.length < 8) {
                    errors.push(t('Password must be at least 8 characters.'));
                  }
                  if (!/[A-Z]/.test(value)) {
                    errors.push(
                      t('Password must have at least 1 uppercase letter.')
                    );
                  }
                  if (!/[0-9]/.test(value)) {
                    errors.push(t('Password must have at least 1 digit.'));
                  }
                  if (!/[!@#$%^&*()]/.test(value)) {
                    errors.push(
                      t(
                        'Password must have at least 1 special character !@#$%^&*().'
                      )
                    );
                  }
                  if (errors.length > 0) {
                    setErrors(errors);
                    return Promise.reject(new Error());
                  }
                  setErrors([]);
                  return Promise.resolve();
                },
              },
            ]}
          >
            <InputPasswordComponent
              placeholder={t('Enter new password')}
              visible={false}
              size={'large'}
            />
          </Form.Item>
          {errors.length > 0 && (
            <ul
              className="flex flex-col justify-start items-start gap-4 self-stretch m-0"
              style={{ color: '#818589' }}
            >
              {errors.map((error, index) => (
                <li key={index}>
                  <span className="text-body-small">{error}</span>
                </li>
              ))}
            </ul>
          )}
          <Form.Item
            label={t('Confirm new password')}
            name={'confirmPassword'}
            dependencies={['new_password']}
            className="self-stretch"
            help={false}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject();
                },
              }),
            ]}
          >
            <InputPasswordComponent
              placeholder={t('Confirm new password')}
              visible={false}
              size={'large'}
            />
          </Form.Item>
        </div>
        <Form.Item className="flex p-40 pt-16 justify-center items-center gap-8 self-stretch">
          <ButtonPrimaryLarge
            title={t('Reset password')}
            className={'grow'}
            type={'submit'}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default ResetPassword;
